import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import GameAbstract from '../core/GameAbstract';
import Template from 'frontools/data/Template';
import { autobind } from 'frontools/decorators/Autobind';
import { Assets } from '../core/Assets';
import NumberUtils from 'frontools/utils/NumberUtils';
import { GameMode, GameManager } from '../core/GameManager';
import { GameEvent } from '../core/GameAbstract';
import GameTimer from '../core/components/GameTimer';
import Context from 'frontools/core/Context';
import Breakpoint from 'frontools/core/Breakpoint';
import Bone, { ILevelConfig } from './Bone';


declare var dataLayer           : any;

export class Titubetibia extends GameAbstract {

    public static instance                  : Titubetibia;
    

    private _gameOn                         : boolean                        = true;

    private _bone                           : Bone;
    private _boneContainer                  : PIXI.Container;
    private _boneConfig                     : ILevelConfig[]                 = [
        {
            character: 'bone',
            framesCount: 63,
        }
    ];

    private _boneTotalFrame                 : number;
    private _boneMiddleFrame                : number;

    public static CLICK                     : string                        = 'click';
    public static TAP                       : string                        = 'tap';

    private _leftGlass                      : PIXI.extras.AnimatedSprite;
    private _rightGlass                     : PIXI.extras.AnimatedSprite;
    private _glassTotalFrames               : number;

    private _mask                           : PIXI.Graphics;
    private _buttonsContainer               : PIXI.Container;
    private _buttonRight                    : PIXI.Container;
    private _buttonLeft                     : PIXI.Container;

    private _clickEnable                    : boolean                        = true;


    constructor() {
        super({
            time: 20,
            results: [
                '0-99',
                '100-179',
                '180-9999'
            ],
            assets: [
                { name: 'bone1', url: 'sprite/bone/bone0001.png', init: false }, { name: 'bone2', url: 'sprite/bone/bone0002.png', init: false }, { name: 'bone3', url: 'sprite/bone/bone0003.png', init: false }, { name: 'bone4', url: 'sprite/bone/bone0004.png', init: false }, { name: 'bone5', url: 'sprite/bone/bone0005.png', init: false }, { name: 'bone6', url: 'sprite/bone/bone0006.png', init: false }, { name: 'bone7', url: 'sprite/bone/bone0007.png', init: false }, { name: 'bone8', url: 'sprite/bone/bone0008.png', init: false }, { name: 'bone9', url: 'sprite/bone/bone0009.png', init: false }, { name: 'bone10', url: 'sprite/bone/bone0010.png', init: false }, { name: 'bone11', url: 'sprite/bone/bone0011.png', init: false }, { name: 'bone12', url: 'sprite/bone/bone0012.png', init: false }, { name: 'bone13', url: 'sprite/bone/bone0013.png', init: false }, { name: 'bone14', url: 'sprite/bone/bone0014.png', init: false }, { name: 'bone15', url: 'sprite/bone/bone0015.png', init: false }, { name: 'bone16', url: 'sprite/bone/bone0016.png', init: false }, { name: 'bone17', url: 'sprite/bone/bone0017.png', init: false }, { name: 'bone18', url: 'sprite/bone/bone0018.png', init: false }, { name: 'bone19', url: 'sprite/bone/bone0019.png', init: false }, { name: 'bone20', url: 'sprite/bone/bone0020.png', init: false }, { name: 'bone21', url: 'sprite/bone/bone0021.png', init: false }, { name: 'bone22', url: 'sprite/bone/bone0022.png', init: false }, { name: 'bone23', url: 'sprite/bone/bone0023.png', init: false }, { name: 'bone24', url: 'sprite/bone/bone0024.png', init: false }, { name: 'bone25', url: 'sprite/bone/bone0025.png', init: false }, { name: 'bone26', url: 'sprite/bone/bone0026.png', init: false }, { name: 'bone27', url: 'sprite/bone/bone0027.png', init: false }, { name: 'bone28', url: 'sprite/bone/bone0028.png', init: false }, { name: 'bone29', url: 'sprite/bone/bone0029.png', init: false }, { name: 'bone30', url: 'sprite/bone/bone0030.png', init: false }, { name: 'bone31', url: 'sprite/bone/bone0031.png', init: false }, { name: 'bone32', url: 'sprite/bone/bone0032.png', init: false }, { name: 'bone33', url: 'sprite/bone/bone0033.png', init: false }, { name: 'bone34', url: 'sprite/bone/bone0034.png', init: false }, { name: 'bone35', url: 'sprite/bone/bone0035.png', init: false }, { name: 'bone36', url: 'sprite/bone/bone0036.png', init: false }, { name: 'bone37', url: 'sprite/bone/bone0037.png', init: false }, { name: 'bone38', url: 'sprite/bone/bone0038.png', init: false }, { name: 'bone39', url: 'sprite/bone/bone0039.png', init: false }, { name: 'bone40', url: 'sprite/bone/bone0040.png', init: false }, { name: 'bone41', url: 'sprite/bone/bone0041.png', init: false }, { name: 'bone42', url: 'sprite/bone/bone0042.png', init: false }, { name: 'bone43', url: 'sprite/bone/bone0043.png', init: false }, { name: 'bone44', url: 'sprite/bone/bone0044.png', init: false }, { name: 'bone45', url: 'sprite/bone/bone0045.png', init: false }, { name: 'bone46', url: 'sprite/bone/bone0046.png', init: false }, { name: 'bone47', url: 'sprite/bone/bone0047.png', init: false }, { name: 'bone48', url: 'sprite/bone/bone0048.png', init: false }, { name: 'bone49', url: 'sprite/bone/bone0049.png', init: false }, { name: 'bone50', url: 'sprite/bone/bone0050.png', init: false }, { name: 'bone51', url: 'sprite/bone/bone0051.png', init: false }, { name: 'bone52', url: 'sprite/bone/bone0052.png', init: false }, { name: 'bone53', url: 'sprite/bone/bone0053.png', init: false }, { name: 'bone54', url: 'sprite/bone/bone0054.png', init: false }, { name: 'bone55', url: 'sprite/bone/bone0055.png', init: false }, { name: 'bone56', url: 'sprite/bone/bone0056.png', init: false }, { name: 'bone57', url: 'sprite/bone/bone0057.png', init: false }, { name: 'bone58', url: 'sprite/bone/bone0058.png', init: false }, { name: 'bone59', url: 'sprite/bone/bone0059.png', init: false }, { name: 'bone60', url: 'sprite/bone/bone0060.png', init: false }, { name: 'bone61', url: 'sprite/bone/bone0061.png', init: false }, { name: 'bone62', url: 'sprite/bone/bone0062.png', init: false }, { name: 'bone63', url: 'sprite/bone/bone0063.png', init: false },
               
                { name: 'arms',         url: 'sprite/arms/arms.json' },

                { name: 'leftGlass',    url: 'sprite/leftGlass/leftGlass.json' },
                { name: 'rightGlass',   url: 'sprite/rightGlass/rightGlass.json' },

                { name: 'fallen1',      url: 'audio/fallen/fallen1.mp3' },
                { name: 'falling1',     url: 'audio/falling/falling1.mp3' },
                { name: 'falling2',     url: 'audio/falling/falling2.mp3' },
                { name: 'falling3',     url: 'audio/falling/falling3.mp3' },
                { name: 'falling4',     url: 'audio/falling/falling4.mp3' },
                { name: 'pfiou1',       url: 'audio/pfiou/pfiou1.mp3' },
                { name: 'pfiou2',       url: 'audio/pfiou/pfiou2.mp3' },
                { name: 'pfiou3',       url: 'audio/pfiou/pfiou3.mp3' },
                { name: 'pfiou4',       url: 'audio/pfiou/pfiou4.mp3' },
                { name: 'pfiou5',       url: 'audio/pfiou/pfiou5.mp3' }
            ]
        });

        // Pseudo singleton
        Titubetibia.instance = this;
    };


    /*
     * @core override
     * _onPreloadComplete - Called when the preload has been completed
     * 
     */
    protected _onPreloadComplete() {
        super._onPreloadComplete();

        this._bone = new Bone(this._boneConfig[0] as ILevelConfig);
        this._boneTotalFrame = Math.ceil(this._bone.config['framesCount']);
        this._boneMiddleFrame = Math.ceil(this._bone.config['framesCount'] / 2);
        this._bone.addListener('reachend', this._onBoneEnd);

        this._boneContainer = new PIXI.Container();

        this._leftGlass             = Assets.sprites['leftGlass'];
        this._glassTotalFrames      = this._leftGlass.totalFrames; 
        this._rightGlass            = Assets.sprites['rightGlass'];

        this._buttonLeft            = this.createButton('left');           
        this._buttonRight           = this.createButton('right');
        this._buttonsContainer      = new PIXI.Container();
        this._buttonsContainer.addChild(this._buttonLeft);
        this._buttonsContainer.addChild(this._buttonRight);

        this._mask = this._drawRect(this._screenWidth, this._screenHeight);
    };


    /*
     * @core override
     * _prepare - Prepare the game components and then starts the countdown
     * 
     */    
    protected _prepare() { 
        
        this._resize();

        this._boneContainer.addChild(this._bone.container);
        this._stage.addChild(this._boneContainer);
        
        this._stage.addChild(this._leftGlass);
        this._leftGlass.pivot.x = this._leftGlass.width / 2;

        this._stage.addChild(this._rightGlass);
        this._rightGlass.pivot.x = this._rightGlass.width / 2;

        if (window.devicePixelRatio > 1) {
            this._boneContainer.scale.x = 1.2;
            this._boneContainer.scale.y = 1.2;

            this._leftGlass.scale.x = .8;
            this._leftGlass.scale.y = .8;
            this._rightGlass.scale.x = .8;
            this._rightGlass.scale.y = .8;     
        } else {
            this._boneContainer.scale.x = .65;
            this._boneContainer.scale.y = .65;

            this._leftGlass.scale.x = .4;
            this._leftGlass.scale.y = .4;
            this._rightGlass.scale.x = .4;
            this._rightGlass.scale.y = .4;
        }

        this._stage.addChild(this._buttonsContainer);

        super._prepare();
    };


    /*
     * @core override
     * _start - Starts the game
     * 
     */
    protected _start() {
        super._start();

        this._buttonLeft.on(Titubetibia.CLICK, this._stabilize, this);
        this._buttonRight.on(Titubetibia.CLICK, this._stabilize, this);
        this._buttonLeft.on(Titubetibia.TAP, this._stabilize, this);
        this._buttonRight.on(Titubetibia.TAP, this._stabilize, this);

        this._bone.timer();
        this._bone.boneFall();
        this._bone.playSounds();

    };


    private _stabilize(e) {
        let type = e.type,
            direction = e.target.name;

        if (this._clickEnable) {
            this._clickEnable = false;
            let timeout = setTimeout(() => { // enable click after delay
                this._clickEnable = true;
            }, 80);

            if (direction === 'left' || e.keyCode === 37) {
                this._bone.moveLeft();
                this._updateScore();
            } else if (direction === 'right' || e.keyCode === 39) {
                this._bone.moveRight();
                this._updateScore();
            }
        }
    }


    protected _updateGlasses() {
        let boneTowardsLeft = Math.ceil(this._bone.actualFrame / this._boneMiddleFrame * 100);
        let leftGlassPercent = Math.ceil(this._glassTotalFrames * boneTowardsLeft / 100);
        let leftGlassPosition = this._glassTotalFrames - leftGlassPercent;
        if (boneTowardsLeft > 0 && boneTowardsLeft <= 100) this._rightGlass.gotoAndStop(leftGlassPosition);
        
        let boneTowardsRight = Math.ceil((((this._bone.actualFrame / this._boneTotalFrame)-1) * 100 * 2));
        boneTowardsRight = Math.abs(boneTowardsRight);
        let rightGlassPercent = Math.ceil(this._glassTotalFrames * boneTowardsRight / 100);
        let rightGlassPosition = this._glassTotalFrames - rightGlassPercent;
        if (boneTowardsRight > 0 && boneTowardsRight <= 100) this._leftGlass.gotoAndStop(rightGlassPosition);
    }


    private _updateScore() {
        this._gameScore.add(this._bone.score);
    }


    @autobind
    private _onBoneEnd() {
        if (this._gameOn) {
            this._gameState.save({score: this._gameScore.score});
            this._gameOn = false;
            this._gameTimer.stop();
            this._end();
        }
    }


    private createButton(name: string) : PIXI.Container {
        var button = new PIXI.Container();
        button.addChild(this._drawRect(this._screenWidth, this._screenHeight, 0x617a72, 1));  
        button.alpha = 0; 
        button.name = name;
        button.x = (name === "left") ? 0 : this._screenWidth;
        button.y = 0;
        button.interactive = true;
        button.buttonMode = true;
        return button;  
    }


    private _drawRect(w: number = this._screenWidth, h: number = this._screenHeight, color: number = 0xFFFFFF, alpha: number = 1) {
        let rect = new PIXI.Graphics;
        rect.beginFill(color, alpha);
        rect.drawRect(0, 0, w, h);
        rect.endFill();
        return rect;
    };


    /*
     * @core override
     * _onTimerComplete - on game timer complete handler
     * @param {event} e - Event
     * 
     */
    protected _onTimerComplete(e) {
        if(this._gameOn) super._onTimerComplete(e);
        this.dispatch({type:'gameOver'});
        this._gameOn = false;
    };


    protected _end() {
        super._end();
    }


    public get gameOn(): boolean {
        return this._gameOn;
    }
    
    public get screenWidth(): number {
        return this._screenWidth;
    }

    public get screenHeight(): number {
        return this._screenHeight;
    }
    

    /*
     * @core override
     * _resize - Resize handler
     * @param {event} e - Event
     * 
     */
    protected _resize(e?: Event) {
        super._resize(e);

        if (this._gameMode === GameMode.PLAYING || typeof e === 'undefined') {
            this._screenHeight = this._renderer.screen.height;
            this._screenWidth = this._renderer.screen.width;
            this._boneContainer.x = this._screenWidth / 2 - this._boneContainer.width / 2;
            this._boneContainer.y = this._screenHeight / 2 - this._boneContainer.height / 1.95;
            
            this._leftGlass.x = this._screenWidth / 2 - this._leftGlass.width;
            this._leftGlass.y = this._screenHeight - this._leftGlass.height * 1.5;
            this._rightGlass.x = this._screenWidth / 2 + this._rightGlass.width;
            this._rightGlass.y = this._screenHeight - this._rightGlass.height * 1.5;

            // Resetting buttons width and height
            (this._buttonLeft.getChildAt(0)  as PIXI.Graphics).height = this._screenHeight;
            (this._buttonLeft.getChildAt(0)  as PIXI.Graphics).width = this._screenWidth/2;
            (this._buttonRight.getChildAt(0) as PIXI.Graphics).height = this._screenHeight;
            (this._buttonRight.getChildAt(0) as PIXI.Graphics).width = this._screenWidth/2;
            this._buttonRight.x = this._screenWidth/2;
        }
    };
}





